module.exports = __webpack_public_path__ + "static/media/25k.01628c52.webp";